import type { FC } from 'react'
import { useState } from 'react'

import RemoveButton from '@/components/RemoveButton'

import Sidebar from './Sidebar'

interface Props {
  customerId: string
  subjectId: string
  refereeId: string
}

const RemoveAccountantReference: FC<Props> = ({ customerId, subjectId, refereeId }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false)

  return (
    <>
      {isSidebarOpen && (
        <Sidebar
          customerId={customerId}
          subjectId={subjectId}
          refereeId={refereeId}
          onClose={() => setIsSidebarOpen(false)}
        />
      )}
      <RemoveButton onClick={() => setIsSidebarOpen(true)} />
    </>
  )
}

export default RemoveAccountantReference
